import React from "react";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { LibraryItem } from "@/contexts/UniversalLibraryContext/types";
import UniversalItemCard from "./UniversalItemCard";

interface Props {
  item: LibraryItem;
  onClick?: (item: LibraryItem) => void;
}

const UniversalItemCardDraggable: React.FC<Props> = ({ item, onClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <UniversalItemCard
        item={item}
        onClick={onClick}
        isDraggable={true}
        dragHandleProps={{ ...listeners, ...attributes }}
        isDragging={isDragging}
      />
    </div>
  );
};

export default UniversalItemCardDraggable; 